import * as Sentry from '@sentry/browser';

const sessionStorageAvailable = () => {
  const test = 'test';
  try {
    sessionStorage.setItem(test, test);
    sessionStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
};

const storeData = (key, data) => {
  if (!sessionStorageAvailable()) {
    return;
  }
  try {
    sessionStorage.setItem(key, JSON.stringify(data));
  } catch (error) {
    Sentry.captureException(error);
  }
};

const getData = (key) => {
  if (!sessionStorageAvailable()) {
    return null;
  }
  try {
    return JSON.parse(sessionStorage.getItem(key));
  } catch {
    return sessionStorage.getItem(key);
  }
};

const storeFormData = (formName, data) => {
  if (!sessionStorageAvailable()) {
    return;
  }
  if (data instanceof Object) {
    const objKeys = Object.keys(data);
    for (let i = 0; i < objKeys.length; i++) {
      const value = data[objKeys[i]];
      // Assign the Filename to a File data parameter
      if (value instanceof FileList) {
        if (value[0]) {
          data[objKeys[i]] = value[0].name;
        } else {
          data[objKeys[i]] = null;
        }
      }
      // Convert an array of items to a Set
      if (value instanceof Array) {
        const set = {};
        value.forEach((item) => {
          set[item] = true;
        });
        data[objKeys[i]] = set;
      }
    }
  }
  try {
    sessionStorage.setItem(formName, JSON.stringify(data));
  } catch (error) {
    Sentry.captureException(error);
  }
};

const getFormData = (formName) => {
  if (!sessionStorageAvailable()) {
    return {};
  }
  try {
    return JSON.parse(sessionStorage.getItem(formName)) || {};
  } catch (error) {
    Sentry.captureException(error);
    return {};
  }
};

export { getData, getFormData, sessionStorageAvailable, storeData, storeFormData };
